<template>
    <svg viewBox="0 0 24 24" :width="size" :height="size">
        <path
            d="M12,4 C15,8 18,13 18,14 C18,17 16.5,20 16.5,20 L7.5,20 C7.5,20 6,17 6,14 C6,13 9,8 12,4 Z"
            fill="none"
            stroke="currentColor"
            stroke-width="1.4"
            stroke-linejoin="round"
        />
    </svg>
</template>

<script setup lang="ts">
interface Props {
    size?: number | string
}

withDefaults(defineProps<Props>(), {
    size: 36,
})
</script>
